// extracted by mini-css-extract-plugin
export default {"list":"WhatToLearn_list__of5cl","list__item":"WhatToLearn_list__item__DnAWc"};